import React from 'react'
import { Link } from 'react-router-dom'
import { useAuthContext } from '../../context/auth.context'
import { AppLinks } from '../../shared/legacy/app-links'
import { usePendingInvites, invitationsText } from '../../shared/sso-workspace/pending-invites'
import { canSwitchOrganization } from '../../shared/organization-switch'
import '../../shared/sso-workspace/sso-workspace.scss'
import '../../shared/sso-workspace/auth-card.scss'

// The landing for someone with no admin navigation in this organization
// (owner feedback 2026-09-27). Before, they got an empty sidebar and a bare
// "downloads" card; now the page says where they are and what to do:
// courses open in the EducationXR app, which is right below. Switch
// organization when they belong to others; their pending invitations, if any.
export const LearnerLanding = () => {
  const authContext = useAuthContext()
  const claims = authContext.state.jwtClaims || {}
  const org = authContext.state.organizationName || claims.organizationName || 'this organization'
  const pending = usePendingInvites()
  const canSwitch = canSwitchOrganization(claims)

  return (
    <div className="h-100 overflow-auto">
      <div className="sw-workspace sa-learner">
        <section className="sa-learner-head" aria-labelledby="learner-title">
          <p className="sa-learner-org">{org}</p>
          <h1 id="learner-title">You're a learner in {org}.</h1>
          <p className="m-0">Open your courses in the EducationXR app.</p>

          {(canSwitch || pending.count > 0) &&
            <div className="sa-learner-actions">
              {canSwitch && <Link className="btn sw-btn" to="/auth/account">Switch organization</Link>}
              {pending.count > 0 &&
                <Link className="btn sw-btn" to="/auth/invitations">
                  {invitationsText(pending.count).replace(/\.$/, '')}
                </Link>}
            </div>}
        </section>

        <section className="sa-learner-apps" aria-label="Get the EducationXR app">
          <AppLinks />
        </section>
      </div>
    </div>
  )
}
